import mixpanel from 'mixpanel-browser';
import { event as gtagEvent } from 'vue-gtag';
import { useRootStore } from '@/stores/root.store';
import * as Sentry from '@sentry/vue';

const useTrack = () => {
  const rootStore = useRootStore();

  const init = (application) => {
    if (!rootStore.configuration.isProduction) return;
    facebookInit();
    sentryInit(application);
    mixpanel.init(rootStore.configuration.mixpanelToken, {
      debug: false,
      ignore_dnt: true,
    });

    window.fbq('init', rootStore.configuration.facebookPixelId);
  };

  const mixpanelIdentify = (email) => {
    if (!rootStore.configuration.isProduction) return;
    mixpanel.identify(email);
  };

  const mixpanelTrack = (event, params = {}) => {
    if (!rootStore.configuration.isProduction) return;
    mixpanel.track(event, params);
  };

  const mixpanelSetUserProperties = (properties = {}) => {
    if (!rootStore.configuration.isProduction) return;
    mixpanel.people.set(properties);
  };

  const gtagTrack = (event, properties = {}) => {
    if (!rootStore.configuration.isProduction) return;
    gtagEvent(event, properties);
  };

  const facebookInit = () => {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  };

  const facebookTrack = (event, parameters = {}) => {
    if (!rootStore.configuration.isProduction) return;
    if (window.fbq) {
      window.fbq('track', event, parameters);
    }
  };

  const sentryInit = (application) => {
    Sentry.init({
      app: application,
      dsn: 'https://e979c3a36b452310534a103119ce8c60@o1900.ingest.us.sentry.io/4508852403240960',
      tracesSampleRate: 0, // Performance Monitoring
      integrations: [],
      release: `${__APP_NAME__}@${__APP_VERSION__}`,
      trackComponents: false,
      logErrors: !rootStore.configuration.isProduction,
    });
  };

  const sentryTrack = (exception) => {
    if (!rootStore.configuration.isProduction) return;
    Sentry.captureException(exception);
  };

  return {
    init,
    mixpanelIdentify,
    mixpanelTrack,
    mixpanelSetUserProperties,
    gtagTrack,
    facebookTrack,
    sentryTrack,
  };
};

export default useTrack;
